<template lang="pug">
v-select(
  :items="timezones"
  item-text="zone"
  item-value="id"
  v-model="inputValue"
  v-bind="$attrs"
  v-on="$listeners"
)
</template>
<script>
import CRUDTimezones from '@/services/API/timezone';

export default {
  props: {
    value: { type: Number, default: null },
  },
  data() {
    return {
      timezones: [],
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  async created() {
    await this.fetchTimezones();
  },
  methods: {
    async fetchTimezones() {
      try {
        const response = await CRUDTimezones.getAll();
        this.timezones = response.data.data;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
  },
};
</script>
